var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"width":"900px","title":"视频预览","visible":_vm.dialogTableVisible},on:{"update:visible":function($event){_vm.dialogTableVisible=$event}}},[_c('VPlayer',{staticClass:"video_player",attrs:{"src":_vm.src}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }